import { fontSize } from "@material-ui/system";
import { isAbsolute } from "upath";

export default () => ({
  superContainer: {
    // background: "#F9F9F9",
    padding: 30,
    fontFamily: "Open sans"
  },
  labelContainer: {
    marginTop: 16
  },
  expansionMargin: {
    marginTop: 20
  },
  imageButtonContainer: {
    marginTop: 16,
    position: "relative"
  },
  changeButton: {
    marginTop: 10,
    opacity: 1,
    height: 40,
    boxShadow: "none",
    textTransform: "capitalize"
  },
  uploadText: {
    fontSize: 16,
    marginTop: 16,
    color: "rgba(51, 51, 51, 0.75)"
  },
  imageText: {
    fontSize: 12,
    // marginTop: 9,
    color: "rgba(51, 51, 51, 0.75)"
  },
  highLightText: {
    fontSize: 16,
    fontWeight: 600
  },
  horizontalLine: {
    height: 1,
    width: "100%",
    borderBottom: "1px solid #EEEEEE",
    margin: "20px 0"
  },
  labelStyle: {
    fontSize: 12
  },
  selectField: {
    width: 360,
    marginBottom: 16,
    borderBottom: "1px solid #EEEEEE",
  },
  marginStyle: {
    marginLeft: 10,
  },
  mainContainer: {
    // display: "flex",
  },
  livePreviewContainer: {
    width: "-webkit-fill-available",
    display: "flex",
    justifyContent: "center",
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    "&:hover": {
      color: "#10A8DB"
    }
  },
  colorCopy: {
    fontWeight: 600,
    fontSize: 14,
    marginLeft: 6,
  },
  previewContainer: {
    position: "absolute",
    top: 115,
    left: "60%",
    transform: "scale(0.9)",
  },
  // subContainer: {
  //   display: "flex",
  //   width: "100%",
  //   justifyContent: "center"
  // },
  // leftContainer: {
  //   // width: "100%",
  //   maxWidth: 600,
  //   marginRight: 15
  //   // padding: 10,
  //   // paddingRigh: 15
  // },
  // rightContainer: {
  //   // width: "100%",
  //   width: 480,
  //   marginLeft: 15
  //   // padding: 10,
  //   // paddingLeft: 15
  // },
  // textCenter: {
  //   textAlign: 'center'
  // },
  // rsvpFormContainer: {
  //   // margin: 20
  // },
  // bannerContainer: {
  //   margin: 20,
  //   height: "100%"
  // },
  // bannerImageContainer: {
  //   width: "100%",
  //   '&:hover': {
  //     opacity: 0.3,
  //   },
  // },
  // buttonContainer: {
  //   display: "grid",
  //   width: 240,
  //   height: 100,
  // },

  // headerContainer: {
  //   margin: 'auto',
  //   padding: 10
  // },
  // venueContainer: {
  //   margin: "25px 0"
  // },
  // titleClass: {
  //   fontFamily: "Open Sans",
  //   fontWeight: "300",
  //   fontSize: 40,
  //   width: "auto",
  //   height: 62,
  //   marginLeft: 30
  // },
  // dateClass: {
  //   fontFamily: "Open Sans",
  //   fontWeight: "600",
  //   fontSize: 56,
  //   width: "auto",
  //   marginLeft: 30
  // },
  // subtitleClass: {
  //   fontFamily: "Raleway",
  //   fontStyle: "normal",
  //   fontWeight: 400,
  //   fontSize: 32,
  //   lineHeight: 38,
  //   letterSpacing: 0.25,
  //   height: 38
  // },
  // bodyClass: {
  //   fontFamily: "Open Sans",
  //   fontStyle: "normal",
  //   fontWeight: 400,
  //   fontSize: 18,
  //   letterSpacing: 0.25,
  //   color: "#333333",
  //   height: "240px",
  //   overflow: "hidden"
  // },
  // headerImageContainer: {
  //   maxWidth: 286,
  //   margin: "20px 0px"
  // },
  // labelContainer: {
  //   width: 900,
  //   height: 62,
  // },
  // editButton: {
  //   marginBottom: 10,
  //   height: 40
  // },

  // rsvpFieldContainer: {
  //   color: "white !important",
  //   textAlign: "center",
  //   background: "#26BBED !important",
  //   position: "relative",
  //   height: 40
  // },
  // rsvpField: {
  //   color: "white !important",
  //   border: "none !important",
  //   textAlign: "center",
  //   background: "transparent !important",
  //   position: "absolute",
  //   bottom: 0,
  //   top: 0,
  //   left: 0,
  //   right: 0,
  //   width: "100%"
  // },
  // bannerBottom: {
  //   marginTop: 34,
  //   // width: 600
  // },
  // mainHeader: {
  //   display: "flex",
  //   alignItems: "center",
  //   justifyContent: "space-between",
  //   background: "white",
  //   borderTop: "1px solid #eeeeee",
  //   borderBottom: "1px solid #eeeeee",
  //   paddingRight: 10
  // },
  // whiteIcon: {
  //   color: "white"
  // },
  // actionButton: {
  //   display: "flex",
  //   justifyContent: "space-between",
  //   width: 172,
  //   height: 32
  // },
  // buttonStyle: {
  //   width: 80,
  //   boxShadow: "none !important"
  // },
  // footer: {
  //   display: "flex",
  //   width: "100%",
  //   justifyContent: "center",
  //   padding: "40px 0",
  // },
  // bannerFrame: {
  //   // width: 600,
  //   minHeight: 340,
  //   position: "relative"
  // },
  // rsvpFormHeading: {
  //   fontSize: 28
  // },
  bottomMargin: {
    paddingBottom: 4
  },
  selectOptionList: {
    padding: 0,
  },
  selectOptionPaper: {
    boxShadow: "0px 0px 30px 2px rgba(0, 0, 0, 0.05) !important",
    border: "1px solid #eeeeee",
    background: "white",
    width: 330,
    maxHeight: 350
  },
  utmContainer: {
    color: "#333",
    fontSize: 16,
    lineHeight: "24px",
    background: "#F9F9F9",
    padding: "8px 12px",
    marginBottom: 14,
    wordBreak: "break-all"
  },
  copiedColor: {
    color: "#66D184"
  },
  shareText: {
    color: "rgba(51, 51, 51, 1)",
    marginBottom: 6
  },
  emailValidation: {
    display: "flex",
    alignItems: "center",
    fontFamily: "Open sans",
  },
})